import { render, staticRenderFns } from "./BillsTable.vue?vue&type=template&id=a758f3a8&scoped=true"
import script from "./BillsTable.vue?vue&type=script&lang=js"
export * from "./BillsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a758f3a8",
  null
  
)

export default component.exports